<template>
  <v-container></v-container>
</template>

<script>
export default {
  name: "QuantityConfirmNew"
}
</script>

<style scoped>

</style>
